import getFlagValue, { FLAG_ENUM } from '../../utils/getFlagValue';
import { addQueueGlobalCount, resetQueueGlobalCount } from '../../../store/emarsys/action';
import { store } from '../../../store';
import {
  PAGE_NAME_TEST_DRIVE,
  SECTION_NAME_TEST_DRIVE_LIST,
} from '../../../constants/emarsys/test-drive';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';

export default function eventClickTestDriveList(
  title: string,
  category: string | undefined,
  sectionName: string,
  buttonName: string,
  menu_cat_lvl1: string,
  otherData?: {
    filterPrice?: string;
    filterSearch?: string;
    filterFuelType?: string;
    filterCapacity?: string;
    orderBy?: string;
    menu_cat_lvl2?: string;
    car_model?: string;
  }
) {
  const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
  if (!isFlagActive) return;
  const state = store.getState();
  const { userData } = state.auth || {
    userData: null,
  };
  if (userData?.customerNo) {
    ScarabQueue.push(['setCustomerId', userData?.customerNo]);
  }

  const valueClickAction: Record<string, string | number | boolean> = {
    page_name: PAGE_NAME_TEST_DRIVE.TEST_DRIVE_LISTING_PAGE,
    page_url: window.location.href,
    page_title: title,
    car_category: category?.toLowerCase(),
    section_name: sectionName,
    button_name: buttonName,
    menu_cat_lvl1: menu_cat_lvl1.toLowerCase(),
    menu_cat_lvl2: otherData?.menu_cat_lvl2?.toLowerCase(),
  };

  if (otherData?.filterCapacity) {
    valueClickAction.filter_capacity = otherData.filterCapacity;
  }

  if (otherData?.filterFuelType) {
    valueClickAction.filter_fueltype = otherData.filterFuelType;
  }

  if (otherData?.filterPrice) {
    valueClickAction.filter_price = otherData.filterPrice;
  }

  if (otherData?.filterSearch) {
    valueClickAction.filter_search = otherData.filterSearch;
  }

  if (otherData?.orderBy) {
    valueClickAction.order_by = otherData.orderBy;
  }

  if (otherData?.car_model) {
    valueClickAction.car_model = otherData.car_model;
  }

  for (const key in valueClickAction) {
    if (valueClickAction[key] === undefined) {
      delete valueClickAction[key];
    }
  }

  ScarabQueue.push(['tag', 'click_button', valueClickAction]);

  if (
    sectionName === SECTION_NAME_TEST_DRIVE_LIST.LISTING_PAGE ||
    sectionName === SECTION_NAME_TEST_DRIVE_LIST.FILTER ||
    sectionName === SECTION_NAME_TEST_DRIVE_LIST.SORT
  ) {
    ScarabQueue.push(['go']);
    store.dispatch(resetQueueGlobalCount());
  } else {
    store.dispatch(addQueueGlobalCount());
  }
}
